export const GLOBAL_LANGUAGE_DB_KEY = 'global-language-1.8'
